module.exports = __webpack_public_path__ + "img/dragon.a5eb43c8.png";